import { Loader2 } from "lucide-react";

export const Loading = ({label}) => {
    return ( 
        <div className="size-full flex justify-center items-center flex-col   italic text-vekin font-semibold ">
            <Loader2 size={48} className="animate-spin text-vekin stroke-vekin stroke-1" />
            <div className="inline-flex gap-1 text-vekin capitalize">
                {label} 
                <div className="loading text-vekin inline-flex gap-0.5"> <span className="text-vekin">.</span><span className="text-vekin">.</span><span className="text-vekin">.</span></div>
            </div>
        </div>
     );
}
 

export const LoadingFull = ({label}) => {
    return ( 
        <div className="backdrop-blur-sm size-full absolute  top-0 left-0 flex justify-center items-center">
            <div className="bg-white p-10 rounded-xl drop-shadow-2xl">
                <Loading label={label} />
            </div>
        </div>
     );
}
 